<template>
  <div class="header"><Header /></div>
  <div>
    <div id="content"><slot /></div>
  </div>
</template>

<script>
import Header from "@/components/_layouts/Header";
import { mapGetters } from "vuex";
import { createdMixin } from "@monolith/mixins";

export default {
  components: { Header },
  name: "Authenticated",
  mixins: [createdMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      socketConnected: "socketConnected",
      getHours: "getHours",
    }),
    thisDate() {
      return this.currentTime.toLocaleDateString();
    },
  },
  watch: {},
  methods: {},
  async mounted() {
    //localStorage.clear();
  },
};
</script>

<style scoped lang="scss">
.outer-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  // min-height: calc(100vh);

  #content {
    width: 100vw;
    margin-left: 5rem;
  }
}

.header {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--primary-colour);
  color: var(--text-colour);
  justify-content: center;
}

@media only screen and (orientation: portrait) {
  .outer-container {
    flex-direction: column;

    #content {
      margin-left: 0rem;
    }
  }

  #menu {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
